import { Box, Button, Drawer, Typography } from "@mui/material";
import React from "react";

interface ResolvedDrawerProps {
  resolvedDrawer: boolean;
  setResolvedDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  handleTicketResolvedAction?: () => void;
}
const ResolvedDrawer: React.FC<ResolvedDrawerProps> = ({
  resolvedDrawer,
  setResolvedDrawer,
  handleTicketResolvedAction,
}) => {
  return (
    <Drawer
      anchor="bottom"
      className="md:hidden"
      open={resolvedDrawer}
      onClose={() => setResolvedDrawer(false)}
      sx={{
        "& .MuiDrawer-paper": {
          paddingRight: "1rem",
          paddingLeft: "1rem",
        },
        zIndex: 1300,
      }}
    >
      <Box className="flex flex-col gap-4 ">
        <Typography className="!pt-4 !px-3 !text-xl !font-medium !flex !justify-center">
          Are you sure you want to resolve the ticket?
        </Typography>

        <Button
          sx={{
            textTransform: "none",
            backgroundColor: "rgba(0, 112, 242, 1)",
            color: "#fff",
            padding: "0.5rem 0 0.5rem 0",
          }}
          onClick={handleTicketResolvedAction}
        >
          Yes
        </Button>
        <Button
          sx={{
            textTransform: "none",
            border: "1px solid rgba(0, 0, 0, 0.2)",
            color: "rgba(40, 40, 40, 1)",
            padding: "0.5rem 0 0.5rem 0",
            marginBottom: "1rem",
          }}
          onClick={() => setResolvedDrawer(false)}
        >
          No
        </Button>
      </Box>
    </Drawer>
  );
};

export default ResolvedDrawer;
